import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-card.js';
import '@adornis/chemistry/elements/components/x-link.js';
import { makeChancenRouter } from '@chancenwerk/client/make-chancen-router.js';
import { authenticationGuard } from '@adornis/user-forms/authentication-guard.js';
import { permissionGuard } from '@adornis/user-forms/permission-guard.js';
import { ANY_CONTEXT } from '@adornis/users/db/a-roles.js';
import '@chancenwerk/client/components/chancen-component-auto-navigation.js';
import { ChancenPermission } from '@chancenwerk/shared/permissions.js';
import '@chancenwerk/client/design/components/cr-flex.js';
import '@chancenwerk/client/design/components/cr-loader.js';
import '@chancenwerk/client/design/components/cr-sidebar.js';
import '@chancenwerk/client/design/components/fonts.js';
import { watch } from '@lit-labs/preact-signals';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '@chancenwerk/client/components/chancen-component-login-redirect.js';
import '@chancenwerk/client/pages/chancen-page-no-permission.js';
import '@chancenwerk/client/pages/chancen-page-not-found.js';
import './components/markt-component-sidebar.js';
import './pages/markt-page-akquise.js';
import './pages/markt-page-overview.js';
import './pages/markt-page-veranstaltung-akquise.js';

const router = makeChancenRouter(
  {
    root: {
      path: '/',
      render: () => html`<markt-page-overview></markt-page-overview>`,
    },
    'markt-akquise': {
      path: '/markt-akquise/:id',
      render: ({ id }) => html`<markt-page-akquise .marktAkquiseID=${id}></markt-page-akquise>`,
    },
    'markt-veranstaltung-akquise': {
      path: '/markt-veranstaltung-akquise/:id',
      render: ({ id }) =>
        html`<markt-page-veranstaltung-akquise .marktAkquiseID=${id}></markt-page-veranstaltung-akquise>`,
    },
  },
  { routerDocumentTitle: 'CHANCENmarkt' },
).init();

@customElement('main-element')
export class MainElement extends ChemistryLitElement {
  override styles() {
    return [{ ':host': { background: this.colors.neutral.shade(50) } }];
  }

  public override render() {
    return authenticationGuard(
      () => {
        return html`${permissionGuard(
          ChancenPermission.markt.LOGIN_MARKT,
          () => html`
            <cr-flex flex ${css({ height: '100%' })}>
              <cr-flex horizontal h100>
                <markt-component-sidebar></markt-component-sidebar>
                <cr-flex id="outer-flex" flex ${css({ overflowY: 'auto', position: 'relative' })}>
                  ${watch(router.outlet)}
                </cr-flex>
              </cr-flex>
            </cr-flex>
          `,
          {
            forbiddenTemplate: html`<chancen-page-no-permission></chancen-page-no-permission>`,
            context: ANY_CONTEXT,
          },
        )}`;
      },
      html`<chancen-component-login-redirect></chancen-component-login-redirect>`,
    );
  }
}
